import { BACKUP_PAYMENT_VIEW } from '@/fixtures'

export default {
  path: 'bup-rental-equipment',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Rental Equipment',
      component: () => import('@/views/menus/BackupPayment/Index'),
      meta: {
        permission: BACKUP_PAYMENT_VIEW
      }
    },
    {
      path: 'detail',
      name: 'Detail Rental Equipment',
      component: () => import('@/views/menus/BackupPayment/View'),
      meta: {
        permission: BACKUP_PAYMENT_VIEW
      }
    }
  ]
}
